import VueRouter from 'vue-router';
import TestBase from '../../../Views/Tests/components/TestBase.vue';
import TestQuestion from '../../../Views/Tests/components/TestQuestion.vue';
import TestSummary from '../../../Views/Tests/components/TestSummary.vue';
import TestIntro from '../../../Views/Tests/components/TestIntro.vue';

const routes = [
  {
    path: '/:id',
    name: 'TestBase',
    component: TestBase,
    children: [
      { path: 'question/', redirect: { name: 'TestBase' } },
      {
        path: 'question/intro',
        name: 'intro',
        component: TestIntro,
      },
      {
        path: 'question/summary',
        name: 'summary',
        component: TestSummary,
      },
      {
        path: 'question/:questionNum',
        name: 'question',
        component: TestQuestion,
      },
    ],
  },
];

export const router = new VueRouter({
  mode: 'history',
  base: '/test',
  routes,
});